import React from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import ProfileCard from "./ProfileCard";
import SettingsCard from "./SettingsCard";

export default function AccountProfile() {
  return (
    // Use minHeight instead of height so the page can grow on mobile
    <Box sx={{ minHeight: "100vh", position: "relative", pb: 5 }}>
      {/* Banner Container */}
      <Box sx={{ width: "100%", height: "35vh" }}>
        <img
          alt="Profile Banner"
          style={{
            width: "100%", // Better than 100vw to prevent horizontal scroll
            height: "100%",
            objectFit: "cover",
            objectPosition: "50% 50%",
            display: "block",
          }}
          src="https://newapp.smartgrowthai.com/smart_banner.png"
        />
      </Box>

      {/* Cards Grid */}
      <Grid
        container
        spacing={3}
        sx={{
          marginTop: "-15vh", // Pulls the grid up over the banner
          px: { xs: 2, md: 7 }, // Added xs: 2 so it doesn't touch screen edges on mobile
          position: "relative",
          zIndex: 1, // Ensures the grid sits above the banner image
        }}
      >
        <Grid item xs={12} md={4}>
          <ProfileCard />
        </Grid>

        <Grid item xs={12} md={8}>
          <SettingsCard />
        </Grid>
      </Grid>
    </Box>
  );
}
